import getEnv from './getEnv';

let sdLoaded = false;

const loadShift = (configurations) => {
	// window check because this tries to render on the server
	// sdLoaded check because render runs twice
	if (typeof window !== 'undefined' && !sdLoaded) {
		const data = {};
		if (configurations) {
			configurations.forEach((configuration) => {
				if (configuration.project === 'shift') {
					// US814620 - This resolves a timing issue for shift legacy tracking
					// This below code will capture calls to window.sd for later use by the sd.js when it is loaded
					// Originally implemented to solve tracking issues for TradePending which loads faster than the sd.js
					window.sd =
						window.sd ||
						((...args) => {
							(window.sd.q = window.sd.q || []).push(args);
						});

					data.scriptLocation =
						getEnv() === 'prod'
							? configuration.liveScriptLocation
							: configuration.defaultScriptLocation;
					data.clientId = configuration.clientId;
				}
			});
		}

		if (Object.keys(data).length > 0) {
			/* eslint-disable func-names,no-param-reassign,no-unused-expressions,prefer-rest-params,no-sequences,prefer-destructuring */
			(function (s, h, i, f, t, d, g, l) {
				(s[d] =
					s[d] ||
					function () {
						(s[d].q = s[d].q || []).push(arguments);
					}),
					(s[d].l = 1 * new Date());
				(g = h.createElement(i)), (l = h.getElementsByTagName(i)[0]);
				g.async = 1;
				g.src = `${f}?containerId=${t}&dl=${d}`;
				l.parentNode.insertBefore(g, l);
			})(
				window,
				document,
				'script',
				data.scriptLocation,
				data.clientId,
				'sd'
			);

			sdLoaded = true;
		}
	}
};

export default loadShift;
